import Header from './component/header';
import { Hero } from './component/hero';
import { AboutSection } from './component/about';
import { ServicesSection } from './component/services';
import { ProductAccordion } from './component/team';
import { TestimonialsSection } from './component/testimonial';
import { ExperienceSection } from './component/expierence';
import { Footer } from './component/footer';

function App() {
  return (
    <>
    <div className="App">
    <Header/>
    <Hero/>
    <AboutSection/>
    <ServicesSection/>
    <ProductAccordion/>
    <ExperienceSection/>
    <Footer/>
     
    </div>
    </>
  );
}

export default App;
